import { render, staticRenderFns } from "./Bando31Fase6.vue?vue&type=template&id=5b1ae59e&scoped=true"
import script from "./Bando31Fase6.vue?vue&type=script&lang=js"
export * from "./Bando31Fase6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ae59e",
  null
  
)

export default component.exports